import React from "react";
import ReactDOM from "react-dom";
import {Style} from "../../core/Style";
import {PickerContextProvider, usePickerContext} from "./hooks/usePickerContext"
import {SeatsPickerContainer} from "./components/SeatsPickerContainer";

export class SeatsPickerClient {

    el;
    styles;
    url;
    provider;
    onValidateSuccess;

    constructor(params) {
        const showSearchForm = params.showSearchForm === undefined ? true : params.showSearchForm
        const showDateSelector = params.showDateSelector === undefined ? true : params.showDateSelector

        this.el = document.getElementById(params.selector);
        this.url = params.url;
        this.provider = params.provider;
        this.externe = params.externe;
        this.labels = params.labels ?? {};
        this.tickets = params.tickets || [];
        this.styles = params.styles || {};
        this.showSearchForm = showSearchForm
        this.showDateSelector = showDateSelector
        this.onValidateSuccess = params.onValidateSuccess;
        this.onBookedSuccess = params.onBookedSuccess;
        this.onInitialized = params.onInitialized;
        this.onExitClicked = params.onExitClicked;
        this.back = params.back ?? false;
        this.otiPassCode = params.otipass_code || null;
    }

    init() {
        if (this.styles.variables) {
            Style.applyVariables(this.el, this.styles.variables);
        }

        const state = {
            url: this.url,
            provider: this.provider,
            tickets: this.tickets,
            labels: this.labels,
            externe: this.externe,
            onBookedSuccess: this.onBookedSuccess,
            onValidateSuccess: this.onValidateSuccess,
            onInitialized: this.onInitialized,
            onExitClicked: this.onExitClicked,
            back: this.back,
            otiPassCode: this.otiPassCode
        };

        const app = (
            <PickerContextProvider initialState={state}>
                <SeatsPickerContainer
                    parent={this.el}
                    showSearchForm={this.showSearchForm}
                    showDateSelector={this.showDateSelector}
                />
            </PickerContextProvider>
        );

        ReactDOM.render(app, this.el);
    }

    destroy() {
        ReactDOM.unmountComponentAtNode(this.el)
    }

    selectDate(value, hour) {
        this.el.dispatchEvent(new CustomEvent('selectDate', { detail: { value, hour }}))
    }

    open() {
        this.el.dispatchEvent(new CustomEvent('open'))
    }

    close() {
        this.el.dispatchEvent(new CustomEvent('close'))
    }
}